import Bird from "@/assets/videos/bird.mp4";
export const videos = {
    Bird,
};
